'use client'
import React from 'react'
import classes from './styles.module.css'
import RecommendedBlogs from './RecommendedBlogs'
import BlogBanner from './components/blog-banner/BlogBanner'
import {BlogDetails as IBlogDetails} from 'types/blogs'
import Navigation from 'v1/common-components/navigation/Navigation'
import ServerContent from './ServerContent'
import Image from 'next/image'
import getZenadmin from 'assets/blogs/GetZenadmin.svg'
import Modal from 'v1/common-components/modal/Modal'
import BookDemoForm from 'v1/page-components/marketing/common/demo-form/BookDemoForm'
import {DemoData} from 'v1/types/home-page'
import BlogTOC from './components/table-of-contents/BlogTOC'

interface BlogDetailsProps {
  details: IBlogDetails
}

const defaultDemoData = {
  isFreeTrialPage: false,
  isNameRequired: true,
  heading: 'Get ZenAdmin for Free',
  buttonText: 'Submit',
  isTermAndCondition: true,
  thankYouTitle: 'Your Account Has Been Created',
  thankYouParagraph:
    'Please check your email for login details to access your ZenAdmin account. Meanwhile, you can schedule a convenient time for a personalized demo.',
}

const BlogDetailsServer = ({details}: BlogDetailsProps) => {
  const [demoData, setDemoData] = React.useState<DemoData>({...defaultDemoData})
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false)
  if (!details) {
    return <></>
  }

  const toggleDemoFormModal = (data: DemoData | null = null) => {
    setDemoData(
      data || {
        ...defaultDemoData,
      },
    )
    setModalOpen(prev => !prev)
  }

  console.log(details?.content)

  return (
    <>
      <div className={classes.container}>
        <div className={classes.navBarContainer}>
          <div className={classes.navBarSubContainer}>
            <Navigation />
          </div>
        </div>
        <div className={classes.bannerParent} id="blog-banner">
          <BlogBanner details={details} />
        </div>
        <div className={classes.blogText}>
          <div className={classes.TOCComponent}>
            <BlogTOC content={details?.content.rendered || ''} />
          </div>
          <div className={classes.blogContent} data-blog-content id="blog-content">
            <ServerContent content={details?.content} />
          </div>
          <div className={classes.getZenadminComponent}>
            <Image
              onClick={() => toggleDemoFormModal({})}
              className={classes.getZenadminImage}
              alt="blog"
              src={getZenadmin}
            />
          </div>
        </div>
        <div className={classes.recommendedSection} id="recommended-section">
          <RecommendedBlogs id={details.id} />
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <BookDemoForm data={demoData} />
      </Modal>
    </>
  )
}

export default BlogDetailsServer
